import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const buttonStyles: React.CSSProperties = {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontSize: '0.7rem', // Smaller on mobile
    padding: '2px 4px',
    marginRight: '5px', // Space between language switcher and wallet button
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#333',
    fontWeight: 'bold',
    transition: 'opacity 0.2s ease-in-out',
    whiteSpace: 'nowrap',
};

const LanguageSwitcher: FC = () => {
    const { t, i18n } = useTranslation();

    const isEnglish = i18n.language.startsWith('en');

    const toggleLanguage = () => {
        const lng = isEnglish ? 'pt' : 'en';
        i18n.changeLanguage(lng);
    };

    return (
        <button
            style={buttonStyles}
            onClick={toggleLanguage}
            aria-label={t(isEnglish ? 'switchToPortuguese' : 'switchToEnglish')}
            title={t(isEnglish ? 'switchToPortuguese' : 'switchToEnglish')}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.7')}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
        >
            EN / PT
        </button>
    );
};

export default LanguageSwitcher;